import React from 'react';

// Checklist-style row used for multi-select lists (events/channels/rules/relays) across the
// CCTV integration forms - a green filled tick when selected, a hollow circle when not.
const SelectableListRow = ({ label, selected, onClick }) => (
    <div
        onClick={onClick}
        style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px 16px',
            borderRadius: '8px',
            cursor: 'pointer',
            border: `1px solid ${selected ? '#22c55e' : '#d1d5db'}`,
            backgroundColor: selected ? '#f0fdf4' : 'transparent',
            width: '260px',
            transition: 'border-color 0.15s ease, background-color 0.15s ease'
        }}
    >
        <i
            className={`pi ${selected ? 'pi-check-circle' : 'pi-circle'}`}
            style={{ fontSize: '18px', color: selected ? '#22c55e' : '#c4c4c4', flexShrink: 0 }}
        />
        <span style={{ color: '#6e6e6e' }}>{label}</span>
    </div>
);

export default SelectableListRow;
